import React from "react";
import ImgError404 from "../../assets/img/Error 404.png";
import styles from "./Error404.module.css";
import { BackButton } from "../";

const Error404 = () => {
  return (
    <div className={styles.errorContainer}>
      <div className={styles.imgYp}>
        <img src={ImgError404} alt="Error 404" className={styles.errorImage} />
        <div className={styles.parrafo}>
          <h3 className={styles.ErrorP}>Esta página no está disponible. </h3>
          <h3 className={styles.ErrorP}>Intente más tarde.</h3>
        </div>
      </div>
      <BackButton />
    </div>
  );
};

export default Error404;
